import * as React from 'react';

import { breakpoints } from '@notino/react-styleguide';
import { GetCatalogProductViewQuery } from '@notino/shared/definitions/types';

import { IProduct } from '@containers/ProductListing/model';
import { styled } from '@linaria/react';

import messages from '../../messages';
import { ProductsSection } from '../ProductsSection';

import { LIST_LABEL } from './constants';
import { useLastVisitedItems } from './useLastVisitedItems';

interface ILastVisitedProductsProps {
  productId: IProduct['id'];
  variants: NonNullable<
    GetCatalogProductViewQuery['productDetailByCatalogMasterId']
  >['variants'][number][];
}

const Wrap = styled.div`
  margin-bottom: 2rem;
  @media (min-width: ${breakpoints.lg}) {
    margin-bottom: 4rem;
  }
`;

export const LastVisitedProducts: React.FC<ILastVisitedProductsProps> = (
  props
) => {
  const items = useLastVisitedItems(props.productId);

  if (!items || !items.length || items.length < 3) {
    return null;
  }

  return (
    <Wrap>
      <ProductsSection
        productIds={items}
        titleMessage={messages.lastVisited}
        titleId="pdLastVisitedProducts"
        containerId="pd-last-visited-products-header"
        listLabel={LIST_LABEL}
        trackProductClick={true}
        trackProductImpression={true}
      />
    </Wrap>
  );
};
